import { Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import * as $ from 'jquery';

@Component({
    selector: 'app-navbar',
    templateUrl: 'navbar.component.html',
    styleUrls: ['navbar.component.scss'],
    providers: [LanguageService],
})

export class NavbarComponent {

    activeLanguage = 'german';
    activePage = 'about';
    deviceWidth;
    navbarLinks: any = {
        'german': {
            about: 'Über',
            philosophy: 'Beratungsphilosophie',
            services: 'Leistungen',
            competence: 'Kompetenz',
            contact: 'Kontakt',
            overview: 'Übersicht',
            bd: 'Business Development',
            ct: 'Reinigungstechnologie',
            semiconductors: 'Halbleitertechnik',
            re: 'Reliability Engineering',
        },
        'english': {
            about: 'About',
            philosophy: 'Consulting philosophy',
            services: 'Services',
            competence: 'Competencies',
            contact: 'Contact',
            overview: 'Overview',
            bd: 'Business Development',
            ct: 'Clean Technologies',
            re: 'Reliability Engineering',
            semiconductors: 'Semiconductors',
        }
    };

    constructor(private ls: LanguageService, private router: Router) {
        ls.getLanguage().subscribe(val => this.activeLanguage = val);
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.activePage = event.url;
            }
        });

        this.onResize();
    }

    onLanguageChange(val: string) {
        this.ls.switchLanguage(val);
    }

    onResize() {
        const prevDeviceWidth = this.deviceWidth;
        this.deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        if (this.deviceWidth < 768 && prevDeviceWidth >= 768) {
            $('.navbar-nav li', 'dropdown-menu a').attr('data-toggle', 'collapse');
            $('.navbar-nav li', 'dropdown-menu a').attr('data-toggle', 'collapse');
        }
        if (this.deviceWidth >= 768 && prevDeviceWidth < 768) {
            $('.navbar-nav li', 'dropdown-menu a').removeAttr('data-toggle');
            $('.navbar-nav li', 'dropdown-menu a').removeAttr('data-target');
        }
    }

    routeTo(target: string) {
      const mq = window.matchMedia('(max-width: 995px)');
      if (mq.matches) {
        this.collapse('.navbar-collapse');
      }
      this.router.navigateByUrl(target);
    }


    collapse(selector) {
      const targets = Array.from(document.querySelectorAll(selector));
      targets.forEach(target => {
        const classList: DOMTokenList = target['classList'];
        classList.remove('show', 'in');
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts